import getStaticElement from '../accessors/get-static-element';

const hasElementAttribute = (elementId, attr) => {
  const element = getStaticElement(elementId);

  return Boolean(element) && element.hasAttribute(attr);
};

export default hasElementAttribute;
